<template>
  <section>
    <li>
      <fieldset>
        <legend>
          <span :id="`party${number}BornInAus-label`" class="label"
            >Was person {{ number }} born in Australia?</span
          >
        </legend>

        <ul class="choices compact">
          <li>
            <input
              type="radio"
              :id="`party${number}BornInAus.yes`"
              value="true"
              :name="`Party ${number} Born in Australia`"
              v-model="bornInAustralia"
            />
            <label :for="`party${number}BornInAus.yes`">Yes</label>
          </li>
          <li>
            <input
              type="radio"
              :id="`party${number}BornInAus.no`"
              value="false"
              :name="`Party ${number} Born In Australia`"
              v-model="bornInAustralia"
            />
            <label :for="`party${number}BornInAus.no`">No</label>
          </li>
        </ul>
      </fieldset>
    </li>
    <li>
      <fieldset>
        <legend>
          <h4>Place of birth</h4>
        </legend>
        <ol class="questions compact">
          <li>
            <label :for="`party${number}BirthSuburbTown`">
              <span class="label">City or town</span>
            </label>

            <input
              autocomplete="off"
              class="titleCaseOnFirstBlur"
              :id="`party${number}BirthSuburbTown`"
              type="text"
              size="50"
              :name="`Party ${number} Birth Suburb`"
              maxlength="255"
              role="presentation"
              v-model="personDetails.birthSuburbTown"
            />
          </li>
          <li v-if="bornInAustralia === 'true'">
            <label
              :id="`party${number}BirthState-label`"
              :for="`party${number}BirthState`"
            >
              <span class="label">State or territory</span>
            </label>
            <select
              class="titleCaseOnFirstBlur"
              :id="`party${number}BirthState`"
              :name="`Party ${number} Birth State`"
              v-model="personDetails.birthState"
            >
              <option value="" disabled="" selected="selected"
                >- please select -</option
              >
              <option value="act">Australian Capital Territory</option>
              <option value="nsw">New South Wales</option>
              <option value="nt">Northern Territory</option>
              <option value="qld">Queensland</option>
              <option value="sa">South Australia</option>
              <option value="tas">Tasmania</option>
              <option value="vic">Victoria</option>
              <option value="wa">Western Australia</option>
            </select>
          </li>
          <li v-if="bornInAustralia === 'false'">
            <label :for="`party${number}BirthCountry`">
              <span class="label">Country</span>
            </label>

            <input
              autocomplete="off"
              class="titleCaseOnFirstBlur"
              :id="`party${number}BirthCountry`"
              type="text"
              size="50"
              :name="`Party ${number} Birth Country`"
              maxlength="255"
              role="presentation"
              v-model="personDetails.birthCountry"
            />
          </li>
        </ol>
      </fieldset>
    </li>
  </section>
</template>
<script>
export default {
  data() {
    return {
      bornInAustralia: "true",
    };
  },
  props: {
    number: String,
    value: Object,
  },
  computed: {
    personDetails: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
